import { z } from 'zod';
import { SignupData } from './signup.data';
import { Signup } from './signup';

export const SignupVerifyRequestSchema = z.object({
    otp: z.string().min(1, 'OTP is required'),
});

export type SignupVerifyRequest = z.infer<typeof SignupVerifyRequestSchema>;

export type SignupVerifyResponse = {
    success: boolean;
    message?: string;
    form?: Partial<Signup>;
    data?: SignupData;
}